import { createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from 'reducers';
import throttle from 'lodash/throttle';
import Core from 'managers/core';
import { loadState, saveState } from './persistState';
import isProduction from '../config';

const persistedState = loadState();

let store;

if (isProduction) {
    // In production adding only thunk middleware
    const middleware = applyMiddleware(thunk);

    store = createStore(rootReducer, persistedState, middleware);
} else {
    // In development mode beside thunk
    // DevTools are added
    const middleware = applyMiddleware(thunk);
    const enhancer = composeWithDevTools(middleware);

    store = createStore(rootReducer, persistedState, enhancer);
}

Core.setStore(store);

store.subscribe(
    throttle(() => {
        const { authentication } = store.getState();
        if (authentication && authentication.authenticated) {
            saveState({
                authentication: store.getState().authentication,
            });
        } else {
            saveState({});
        }
    }, 1000),
);

export default store;
